<div class="d-flex justify-content-between dialog-title">
  <div>
    <p class="mb-0 mt-1 dialog-title">Checkout Order</p>
  </div>
  <div>
    <button [mat-dialog-close]="true" mat-icon-button>
      <mat-icon class="dialog-icon">close</mat-icon>
    </button>
  </div>
</div>
<hr>
  <div mat-dialog-content>
    <div class="row">
      <div class="col-7">
        <div class="scrollbar">
          <div class="d-flex justify-content-center">
            <div id="print-section">
              <div style="width: 250px">
                <div [ngStyle]="shouldApplyWidth ? {'width': '2.5in'} : {'width': '3in'}" style="background-color: white; padding-bottom: 30px" class="ruda-font">
                  <div>
                  <!--                <img alt="logo" height="90" src="./assets/images/Revised_logo.png" style="-->
                  <!--              padding-top: 10px;-->
                  <!--              padding-bottom: 10px;-->
                  <!--              display: block;-->
                  <!--              margin-left: auto;-->
                  <!--              margin-right: auto;-->
                  <!--            " width="90"/>-->
                </div>
                <div style="padding-left: 10px; padding-right: 10px">
                  <!-- Address -->
                  <div style="border-top: 2px solid; border-bottom: 2px solid;">
                    <p style="
                                      text-align: center;
                                      text-transform: uppercase;
                                      font-weight: bold;
                                      padding: 10px 0 0 0;
                                    ">
                        {{ restaurantDetail?.restaurantDetail?.name }}
                      </p>
                      <!--                    <div class="d-flex justify-content-center">-->
                      <!--                      <img ngSrc="assets/images/logo_b&w.jpeg" alt="logo" height="90" width="140"-->
                      <!--                           priority>-->
                    <!--                    </div>-->
                    <p style="text-align: center; font-size: smaller;">
                      {{ restaurantDetail?.restaurantDetail?.address }}
                      <br/> {{ restaurantDetail?.restaurantDetail?.phone }} <br/>
                    </p>
                    <div class="d-flex justify-content-between">
                      <p style="font-size: 12px">{{ restaurantDetail?.restaurantDetail?.web }}</p>
                      <p style="font-size: 12px">{{ restaurantDetail?.restaurantDetail?.email }}</p>
                    </div>
                  </div>

                  <!-- Time -->
                  <div class="bill-meta" style="width: 100%; border-bottom: 2px solid; font-size: 10px">
                    <span class="bill-meta-cell">
                      <span>Type</span>
                      <span>{{ orderType[data.onGoingOrder.orderType] }}</span>
                    </span>
                    <span class="bill-meta-cell">
                      <span>Order No</span>
                      <span>{{ data.onGoingOrder.orderNumber }}</span>
                    </span>
                    <span class="bill-meta-cell">
                      <span>Items</span>
                      <span>{{ data.onGoingOrder.cartResponseDetails.length }}</span>
                    </span>
                    <span class="bill-meta-cell">
                      <span>Cashier</span>
                      <span>{{ userName }}</span>
                    </span>
                    <span class="bill-meta-cell">
                      <!-- No label: the date starts where the second column's labels start. -->
                      <span class="bill-meta-wide">{{ date | date: 'yyyy/MM/dd HH.mm' }}</span>
                    </span>
                  </div>


                  <!-- Table -->
                  <div style="margin-top: 5px; padding-bottom: 10px;">
                    <!-- Mirrors the row layout below - same margin-left and column widths - so
                         the headings sit directly above their numbers. -->
                    <div style="border-bottom: 2px solid; font-weight: bold; font-size: smaller; text-transform: uppercase; display: flex; line-height: 30px">
                      <p style="flex: 0 0 130px; text-align: left; font-size: 10px">Item Name</p>
                      <div style="display: flex; flex: 1">
                        <p style="width: 35%; text-align: right; font-size: 10px">Rate</p>
                        <p style="width: 22%; text-align: right; font-size: 10px">Qty</p>
                        <p style="width: 43%; text-align: right; font-size: 10px">Amount</p>
                      </div>
                    </div>
                    @for (orderItem of data.onGoingOrder.cartResponseDetails; track orderItem; let i = $index) {
                      <div>
                        <div class="d-flex">
                          <!--                        <p-->
                          <!--                          style="text-align: left; padding-top: 5px; font-size: 12px;">{{ foodItemCode(orderItem.foodId) }}-->
                        <!--                        </p>-->
                        <p style="text-align: left; padding-top: 5px; font-size: 12px">
                          {{ orderItem.foodId | foodItemName: data.foods }} -
                          <small
                            style="margin: 0"><i>{{ orderItem.foodQuantityTagId! | quantityTagName: foodItemQuantity }}</i></small>
                          </p>
                        </div>
                        <div style="display: flex; margin-left: 130px">
                          <p
                            style="width: 35%; text-align: right; font-size: 12px">{{ orderItem.totalPrice / orderItem.quantity | number }}
                          </p>
                          <p style="width: 22%; text-align: right; font-size: 12px">{{ orderItem.quantity }}</p>
                          <p style="width: 43%; text-align: right; font-size: 12px">{{ orderItem.totalPrice | number }}</p>
                        </div>
                      </div>
                    }

                  </div>

                <!-- Grand Total -->
                <div style="border-bottom: 2px solid; padding-bottom: 10px">
                  <div
                      style="width: 100%; display: flex; justify-content: space-between; padding: 5px 0 0 0; font-weight: bold;
                      font-size: 15px;">
                    <div>
                      <p>Total Amount</p>
                    </div>
                    <div>
                      <p>{{ totalPrice }}</p>
                    </div>
                  </div>
                  @if (discountAdded) {
                    <div style="width: 100%; display: flex; justify-content: space-between; font-size: 12px;">
                      <div>
                        <p style="margin-bottom: 0">Discount</p>
                      </div>
                      <div>
                        <p style="margin-bottom: 0">{{ discount | number }}</p>
                      </div>
                    </div>
                  }
                  @if (serviceChargeChecked) {
                    <div
                      style="width: 100%; display: flex; justify-content: space-between; font-size: 12px;">
                      <div>
                        <p style="margin-bottom: 0">Service Charge</p>
                      </div>
                      <div>
                        <p style="margin-bottom: 0">{{ serviceCharge | number }}</p>
                      </div>
                    </div>
                  }

                  @if (taxChecked) {
                    <div
                      style="width: 100%; display: flex; justify-content: space-between; font-size: 12px;">
                      <div>
                        <p style="margin-bottom: 0">Tax</p>
                      </div>
                      <div>
                        <p style="margin-bottom: 0">{{ tax | number }}</p>
                      </div>
                    </div>
                  }

                  <div class="text-weight" style="font-size: 12px">::::::::: PAYMENTS :::::::::</div>

                  @if (paidAdded) {
                    <div
                      style="width: 100%; display: flex; justify-content: space-between; font-size: 12px;">
                      <div>
                        <p style="margin-bottom: 0"
                        class="text-weight">{{ paymentMethod[billForm.get('paymentMethod')?.value] | capitalize }}</p>
                      </div>
                      <div>
                        <p style="margin-bottom: 0">{{ billForm.get('paidAmount')?.value | number }}</p>
                      </div>
                    </div>
                  }
                  <div
                      style="width: 100%; display: flex; justify-content: space-between; padding: 0 0 0 0; font-weight: bold;
                      font-size: 15px">
                    <div>
                      <p style="margin-bottom: 0">Net Amount</p>
                    </div>
                    <div>
                      <p style="margin-bottom: 0">{{ grandTotal | number }}</p>
                    </div>
                  </div>
                  @if (paidAdded) {
                    <div
                      style="width: 100%; display: flex; justify-content: space-between; font-size: 12px;">
                      <div>
                        <p style="margin-bottom: 0">Change</p>
                      </div>
                      <div>
                        <p style="margin-bottom: 0">{{ balance | number }}</p>
                      </div>
                    </div>
                  }
                </div>

                <div style="border-bottom: 2px solid" class="d-flex justify-content-center">
                  <svg id="barcode"></svg>
                </div>
                <!-- Footer -->
                <div style="border-bottom: 2px solid">
                  <div style="display: flex; flex-direction: column; padding: 10px 0 10px 0; align-items: center">
                    <p style="text-transform: uppercase; font-size: 12px; margin: 0">
                      ~ Thank You ~
                    </p>
                    <p style="margin: 0; font-size: 12px">See you Again</p>
                    <p style="margin: 4px 0 0; font-size: 9px">System developed by Trangle (Pvt) Ltd</p>
                  </div>
                </div>
                <div style="text-align: center">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-5">
    <form nz-form [formGroup]="billForm">

      <div formGroupName="discountDetail">
        <div class="mt-3">
          <nz-form-label>Discount</nz-form-label>
          <nz-form-control [nzErrorTip]="errorTpl">
            <nz-input-number (input)="onDiscountAdded()" [nzMin]="0" class="w-100"
              formControlName="discountPercentage"
            nzPlaceHolder="Discount should be between 0 - {{data.onGoingOrder.marginPercentage  | number: '1.2-2'}}"></nz-input-number>
            <ng-template #errorTpl let-control>
              @if (control.errors?.['max']) {
                Maximum discount is {{ data.onGoingOrder.marginPercentage | number: '1.2-2' }}
              }
            </ng-template>
          </nz-form-control>
        </div>
      </div>

      <label class="d-flex  justify-content-end py-1" nz-checkbox [(ngModel)]="serviceChargeChecked"
        [ngModelOptions]="{standalone: true}"
      (ngModelChange)="updateCalculations()">Include service charge</label>

      <label class="d-flex  justify-content-end py-1" nz-checkbox [(ngModel)]="taxChecked"
        [ngModelOptions]="{standalone: true}"
      (ngModelChange)="updateCalculations()">Include Tax</label>

      <div class="d-flex justify-content-between mb-3">
        <button class="w-100 small-btn-width btn-radius" ngxPrint printSectionId="print-section" nz-button
          nzType="primary" nzGhost [useExistingCss]="true">
          Print Bill
        </button>
      </div>

    </form>
  </div>
</div>
</div>
